import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const Banner = () => {
    const { language } = useLanguage();
    const [loading, setLoading] = useState(true);

    const desktopBanner = language === 'fa' ? '/banner.svg' : '/banner-eng.svg';
    const mobileBanner = language === 'fa' ? '/banner-m.svg' : '/banner-m-eng.svg';

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 300);
        return () => clearTimeout(timer);
    }, [language]);

    if (loading) {
        return (
            <div className="w-full h-[200px] sm:h-[300px] md:h-[400px] bg-gray-100 animate-pulse" />
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
        >
            <img src={desktopBanner} className="w-full hidden md:block" alt="Banner" />
            <img src={mobileBanner} className="w-full block md:hidden" alt="Banner Mobil" />
        </motion.div>
    );
};

export default Banner;